// removed by extract-text-webpack-plugin
module.exports = {"container":"styles__container___2MHei","subject":"styles__subject___l-6qa","infoContainer":"styles__infoContainer___6TVmz","infoText":"styles__infoText___14u2p","message":"styles__message___2X5wT"};


//////////////////
// WEBPACK FOOTER
// ./src/views/collaborate/sent-message-panel/note-details/styles.css
// module id = 1102
// module chunks = 0